import stateReducer from "./reducer";

import { combineReducers } from "redux"

const rootReducer = combineReducers({
    stateReducer,
})

export default rootReducer